import NotificationsContext, {
  NotificationsContextProvider as NotificationsProvider,
} from './NotificationsContext';

const NotificationsContextProvider = NotificationsProvider;

export { NotificationsContext as default, NotificationsContextProvider };
